export const parseQueryInt = (
	query: string | string[] | undefined,
): number | undefined =>
	typeof query !== 'string' ? undefined : parseInt(query)
